function b(t, e) {
  return fetch(t, e);
}
export {
  b as stubbableFetch
};
//# sourceMappingURL=StubbableFetch.js.map
